import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { IntegrationCredential } from '../../shared/models/integration-credential';
import { Integration } from '../../shared/enums/integration.enum';

@Component({
  selector: 'sp-add-connected-app-credential',
  templateUrl: './add-connected-app-credential.component.html',
  styleUrls: ['./add-connected-app-credential.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AddConnectedAppCredentialComponent implements OnChanges {

  @Input() integrationId: number;
  @Output() addCredential = new EventEmitter<IntegrationCredential>();
  @Output() cancel = new EventEmitter();

  cincFormGroup = this.fb.group({
    name: ['', Validators.required],
    apiBaseUrl: ['', Validators.required],
    accessTokenUrl: ['', Validators.required],
    clientId: ['', Validators.required],
    clientSecret: ['', Validators.required],
    scope: ['', Validators.required],
  });

  vantacaFormGroup = this.fb.group({
    name: ['', Validators.required],
    apiBaseUrl: ['', Validators.required],
    clientId: ['', Validators.required],
    clientSecret: ['', Validators.required],
    scope: ['', Validators.required],
  });

  appFolioFormGroup = this.fb.group({
    name: ['', Validators.required],
    apiBaseUrl: ['', Validators.required],
    clientId: ['', Validators.required],
    clientSecret: ['', Validators.required],
    partnerId: ['', Validators.required],
  });

  eUnifyFormGroup = this.fb.group({
    name: ['', Validators.required],
    apiBaseUrl: ['', Validators.required],
    clientId: ['', Validators.required],
    clientSecret: ['', Validators.required],
    partnerId: ['', Validators.required],
  });


  constructor(private fb: FormBuilder) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['integrationId']) {
      this.cincFormGroup.reset();
      this.vantacaFormGroup.reset();
      this.appFolioFormGroup.reset();
    }
  }

  onAddCredential() {
    this.addCredential.emit(this.credentialsFormGroup.value as IntegrationCredential);
  }

  onCancel() {
    this.cancel.emit();
  }

  get isCinc() {
    return this.integrationId == Integration.Cinc as number;
  }

  get isVantaca() {
    return this.integrationId == Integration.Vantaca as number;
  }

  get isAppFolio() {
    return this.integrationId == Integration.AppFolio as number;
  }

  get isEUnify() {
    return this.integrationId == Integration.eUnify as number;
  }

  get credentialsFormGroup() {
    switch (this.integrationId) {
      case Integration.Cinc:
        return this.cincFormGroup;

      case Integration.Vantaca:
        return this.vantacaFormGroup;

      case Integration.AppFolio:
        return this.appFolioFormGroup;

      case Integration.eUnify:
        return this.eUnifyFormGroup;

      default:
        break;
    }
  }
}
